import { useQuery } from 'react-query';
import { queryCompanyNAF } from './useCompanyNAF.query';
import { UseCompanyOptions } from './useCompanyNAF.types';
import { Company } from '../../../types/models/company/company.types';

export const COMPANY_NAF_QUERY_KEY = 'COMPANY_NAF';

export const useCompanyNAF = (options?: UseCompanyOptions) => {
  return useQuery<Company & { domains: [number, string][] }, Error>(COMPANY_NAF_QUERY_KEY, () => queryCompanyNAF(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
